import * as Sentry from "@sentry/browser";

const loadYoutube = callback => {
    loadJS('https://www.youtube.com/iframe_api', callback);
};

const renderWithYoutubeApi = videoData => {
    const $container = $(videoData.container).find('[data-youtube-player-placeholder]');
    const playerId = $container.attr('id');

    const videoId = videoData.code;

    let parameters = {
        rel: 0,
        modestbranding: 1,
        showinfo: 0
    };

    const dataParameters = videoData.parameters;
    if (dataParameters) {
        try {
            parameters = JSON.parse(JSON.stringify(dataParameters));
        } catch (err) {
            Sentry.captureException(err);
        }
    }

    if (typeof YT !== 'undefined') {
        YT.ready(() => {
            new YT.Player(playerId, {
                height: videoData.height || '390',
                width: videoData.width || '640',
                videoId: videoId,
                playerVars: parameters,
                events: {
                    'onReady': player => {
                        videoData.onReady(player);
                    },
                    'onStateChange': videoData.onStateChange
                }
            });
        });
    }
};

const renderYoutubePlayer = videoData => {
    if (typeof YT === 'undefined') {
        loadYoutube(() => {
            renderWithYoutubeApi(videoData);
        });
    } else {
        renderWithYoutubeApi(videoData);
    }
};

export { loadYoutube, renderYoutubePlayer };